import { render, staticRenderFns } from "./ExpertFromClan.vue?vue&type=template&id=1785d013&scoped=true&"
import script from "./ExpertFromClan.vue?vue&type=script&lang=js&"
export * from "./ExpertFromClan.vue?vue&type=script&lang=js&"
import style0 from "./ExpertFromClan.vue?vue&type=style&index=0&id=1785d013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785d013",
  null
  
)

export default component.exports